import { getReferenceDataCriteriaArguments } from '../../containers/base-filter-bar-container/reference-data-criteria-arguments';
import { staticCriterionArguments } from './static-criteria-arguments';

export const getCriterionArguments = (state) => {
  return {
    ...getReferenceDataCriteriaArguments(state),
    ...staticCriterionArguments(state),
  };
};
